import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import { observer } from 'mobx-react-lite';
import { FileModel } from 'entities/file/model/fileModel';
import { TableModel } from 'entities/table/model/tableModel';
import { ExplorerEntityTypes } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import MobileItemDownload from 'shared/lib/extendedComponents/grids/components/mobileItemDownload';
import { downloadFile } from 'app/api/api';
import ItemSizeCell from 'shared/lib/extendedComponents/grids/components/itemSizeCell';
import ItemFormatCell from 'shared/lib/extendedComponents/grids/components/itemFormatCell';
import DesktopFileNameCell from 'shared/lib/extendedComponents/grids/components/fileNameCell/desktopFileNameCell';

export default observer(function FileOrTableItem({
  itemModel,
  ...props
}: BoxProps & { itemModel: FileModel | TableModel }) {
  const navigate = useNavigate();
  const { getFileSearchParams, getTableSearchParams } = useSearchParamsUtils();

  const itemData = itemModel.data;

  const navigateToFile = ({ fileId }: { fileId: string }) => {
    navigate({
      pathname: '/explorer',
      search: getFileSearchParams({
        fileId,
      }),
    });
  };

  const navigateToTable = ({ tableId }: { tableId: string }) => {
    navigate({
      pathname: '/explorer',
      search: getTableSearchParams({
        tableId,
      }),
    });
  };

  const { isLessLaptop, isLessTablet } = useBooleanScreens();

  return itemData ? (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <DesktopFileNameCell
        name={itemData.name || ''}
        preview={null}
        lastChangeAuthor={null}
        onClick={() => {
          if (itemData.section_id) {
            itemModel.type === ExplorerEntityTypes.FILE
              ? navigateToFile({
                  fileId: itemModel.id,
                })
              : navigateToTable({
                  tableId: itemModel.id,
                });
          }
        }}
      ></DesktopFileNameCell>
      {isLessTablet ? (
        <MobileItemDownload
          onDownload={() =>
            downloadFile({
              id: itemData.id,
              name: itemData.name || '',
            })
          }
        ></MobileItemDownload>
      ) : isLessLaptop ? (
        <Box sx={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <ItemSizeCell size={itemData.size}></ItemSizeCell>
          <ItemFormatCell format={itemData.type || ''}></ItemFormatCell>
          <MobileItemDownload
            onDownload={() =>
              downloadFile({
                id: itemData.id,
                name: itemData.name || '',
              })
            }
          ></MobileItemDownload>
        </Box>
      ) : (
        <ItemFormatCell format={itemData.type || ''}></ItemFormatCell>
      )}
    </Box>
  ) : null;
});
